import { CharterType } from "__generated__/enums";
import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { getCharterTypeColor } from "view/charters/utils/CharterUtils";

const CharterTypeSelect = <Multiple extends boolean = false,>({
	...props
}: Omit<SelectProps<CharterType, Multiple>, "fetchOptions" | "paginated">) => {
	return (
		<Select
			disableSearch
			getOptionColor={option => getCharterTypeColor(option)}
			{...props}
			fetchOptions={Object.values(CharterType)}
			getOptionLabel={props.getOptionLabel ?? (option => intl.formatMessage({ id: option }))}
			value={props.value || null}
		/>
	);
};

export default CharterTypeSelect;
